<template>
  <div class="checkout-total">
    <div class="checkout-total__banner">
      <p class="headline-sm">סיכום הזמנה</p>
      <div :class="step===1 || shipping ==='' ? 'first-step-checkout-side' : ''">

        <div v-for="total in totals" :class="`tl-${total.code}`" class="checkout-total__line">
          <span v-if="total.value_text !== '₪0'">{{ total.title }}</span>
          <span v-if="total.value_text !== '₪0'" dir="ltr" class="price-data">
            <span v-if="total.code === 'total'">
              <div v-if="total.discountSale > 0">
                <div class="ne-headline-sm">
                  ₪{{ total.value}}
                </div>
              </div>
            </span>
            ₪{{ total.value - total.discountSale }}
          </span>
        </div>
      </div>
    </div>

    <div style="display: none;" v-if="step == 1" class="checkout-total__input">
      <input type="text" placeholder="הזן קוד קופון">
    </div>
    <!--        <div v-if="step == 1" class="checkout-total__input">
                <input type="text" placeholder="הזן Card Gift">
            </div>-->

    <template v-for="total in totals">
      <template v-if="total.code === 'total'">
        <div v-if="total.gifts.status == 1" class="gift">
          <template v-if="total.gifts.products.length > 0">
            <div class="gift-product">
              <CustomDropdown :step="step" :options="total.gifts.products.map(
                gift => ({value: gift.id, img: gift.image, text: gift.model+' '+gift.name, name: gift.name, model: gift.model}))" />
            </div>
          </template>
          <div v-if="total.gifts.price_from > 0" class="gift-text">
            <div class="gift-text-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px" height="24px" viewBox="0 0 30 30">
                <path fill-rule="evenodd"  fill="#019CDE"
                      d="M25.607,4.393 C22.773,1.560 19.007,-0.000 15.000,-0.000 C10.993,-0.000 7.227,1.560 4.393,4.393 C1.560,7.226 -0.000,10.993 -0.000,15.000 C-0.000,19.007 1.560,22.773 4.393,25.607 C7.227,28.440 10.993,30.000 15.000,30.000 C19.007,30.000 22.773,28.440 25.607,25.607 C28.440,22.773 30.000,19.007 30.000,15.000 C30.000,10.993 28.440,7.226 25.607,4.393 ZM15.000,4.101 C16.777,4.101 18.223,5.547 18.223,7.324 C18.223,9.101 16.777,10.547 15.000,10.547 C13.223,10.547 11.777,9.101 11.777,7.324 C11.777,5.547 13.223,4.101 15.000,4.101 ZM19.101,24.609 L10.898,24.609 L10.898,22.851 L12.656,22.851 L12.656,14.062 L10.898,14.062 L10.898,12.305 L17.344,12.305 L17.344,22.851 L19.101,22.851 L19.101,24.609 Z"/>
              </svg>
            </div>
            <div class="gift-text-2">
              <span>
                הוסיפו מוצרים לעגלה בסכום של {{ total.gifts.price_from }} ש"ח ומעלה וקבלו מתנה לבחירה המשך
              </span>
            </div>
          </div>
        </div>
      </template>
    </template>

    <button v-if="step === 1" class="btn-green" @click="onNext" id="begin_checkout" type="button" role="button" aria-label="הזמנה">
      המשך הזמנה
    </button>
    <button v-else-if="step === 2" class="btn-green" :class="enabled ? '' : 'disabled'" @click="onNext" id="add_payment_info" type="button" role="button" aria-label="לתשלום">
      לתשלום
    </button>
    <button v-else class="btn-green" @click="onNext">
      המשך
    </button>
  </div>
</template>

<script>
import {onMounted, ref, toRefs} from "vue";
import CustomDropdown from "../dropdownWithImage.vue";

const selectedGift = ref(null);
const handleSelectedOption = (newValue) => {
  selectedGift.value = newValue;
  console.log("Получено из дочернего компонента:", newValue);
}

export default {
  components: {CustomDropdown},
  name: "CheckoutTotal",
  props: {
    step: {
      type: Number,
      default: 1
    },
    shipping: {
      type: String,
      default: ''
    },
    totals: {
      type: Object,
      default: () => {
        return []
      }
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    filteredTotals() {
      if((this.props?.totals ?? []).length) {
        return this.props.totals
      }
      return [];
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    onNext() {
      const giftProduct = document.querySelector('.gift-product');
      if (this.step === 1 && giftProduct)
      {
        const hasImage = giftProduct.querySelector('.dropdown-header img');

        if (!hasImage) {
          giftProduct.style.border = '1px solid red';
          return;
        }
      }
      this.$emit('next');
    }
  }
}
</script>

<style scoped lang="scss">
  .disabled {
    pointer-events: none;
    background-color: #434343;
    border-color: #434343;
  }
  .btn-green {
    &:hover {
      background-color: #009cde;
      border-color: #009cde;
    }
  }

  .checkout-total {
    z-index: 10;
    @media (max-width: 1440px) and (min-width: 1025px) {
      left: 50px;
    }
    @media (max-width: 768px) and (min-width: 481px) {
      right: 0%;
      margin-bottom: 265px;
    }
    @media (max-width: 4809px) {
      margin-bottom: 265px;
    }
  }

  .checkout-total__banner {
    background-color: white;
  }

  .checkout-total__line.tl-total span {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
  }

  .ne-headline-sm {
    padding-left: 10px;
    font-size: 18px;
    line-height: 1;
    color: #888888;
    //right: 5%;
    text-decoration: line-through;
    font-weight: 400;
  }

  .gift {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .gift-product {
    margin-bottom: 15px;
  }

  //.gift-select-products {
  //  width: 100%;
  //}

  .gift-text {
    display: flex;
  }

  .gift-text-svg {
    margin-left: 10px;
  }

  .gift-text-2 {
    font-family: 'Arimo', sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 1; /* 100% */
    letter-spacing: 0; /* 0% от размера шрифта */
    text-align: right;
    text-transform: uppercase;
    color: #019CDE;
  }
</style>
